import React, { Component, Fragment } from 'react';

import AppsManager from 'lib/AppsManager';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import Button from 'components/Button/Button.react';
import Icon from 'components/Icon/Icon.react';
import history from 'dashboard/history';
import styles from 'dashboard/Apps/AppsIndex.scss';
import Empty from './Empty.react';

import AppRow from './AppRow.react';

class AppsIndex extends Component {
  constructor(props) {
    super(props);

    this.subsection = 'Apps';

    this.state = {
      loading: true,
      search: '',
      currentUserApps: [],
      showDeleteAppModal: false,
      password: '',
      appName: '',
      appNameToDelete: '',
    };
  }

  componentDidMount() {
    const currentUserApps = AppsManager.apps();
    let total_users = 0;

    currentUserApps.forEach((app) => {
      total_users += app.users;
    });

    this.setState({
      loading: false,
      currentUserApps,
    });

    Intercom('update', {
      total_apps: currentUserApps.length,
      total_apps_users: total_users,
      avg_users_per_apps: parseInt(total_users / currentUserApps.length),
    });
  }

  renderAppRows = () => {
    const { search, currentUserApps } = this.state;

    const apps = search && search !== '' ? currentUserApps.filter((app) => app.name.toLowerCase().includes(search)) : currentUserApps;

    const result = apps.map((app) => (
      <AppRow key={app.id} app={app} />
    ));

    return result;
  }

  updateSearch(e) {
    this.setState({ search: e.target.value });
  }

  render() {
    const { currentCustomer, location } = this.props;
    const {
      is_trial,
      has_payment_method,
      card,
    } = currentCustomer;

    const pages = ['/products/apps', '/tickets/new'];
    const classes = [styles.index, pages.includes(location.pathname) ? styles.dashboard : null].join(' ');

    let footerContent;

    if (is_trial) {
      footerContent = (
        <Fragment>
          <span>&nbsp;</span>
          <Button color="green" value="Create New App" icon="icon-plus" onClick={() => { history.push('/create'); }} />
        </Fragment>
      );
    } else {
      if (has_payment_method) {
        if (['valid', 'expiring'].includes(card.status)) {
          footerContent = (
            <Fragment>
              <span>&nbsp;</span>
              <Button color="green" value="Create New App" icon="icon-plus" onClick={() => { history.push('/create'); }} />
            </Fragment>
          );
        } else {
          footerContent = (
            <Fragment>
              <span>Update your credit card to create your apps.</span>
              <span>&nbsp;</span>
              <Button color="green" value="Update Credit Card" icon="icon-plus" onClick={() => { history.push('/billing/edit_card'); }} />
            </Fragment>
          );
        }
      } else {
        footerContent = (
          <Fragment>
            <span>Add your credit card to create your apps.</span>
            <span>&nbsp;</span>
            <Button color="green" value="Add Credit Card" icon="icon-plus" onClick={() => { history.push('/billing/add_card'); }} />
          </Fragment>
        )
      }
    }

    // Show Empty apps Page
    if (this.state.currentUserApps.length === 0) {
      return (
        <Empty footerContent={footerContent} className={classes} />
      );
    }

    return (
      <div className={classes}>
        <div className={styles.header}>
          <div className={styles.searchbar}>
            <Icon width={18} height={18} name="search-outline" fill="#788c97" />
            <input ref="searchbar" className={styles.search} onChange={this.updateSearch.bind(this)} value={this.state.search} placeholder="Start typing to filter&hellip;" />
          </div>
        </div>
        <div className={styles.wrapper}>
          <ul className={styles.apps}>
            {this.renderAppRows()}
          </ul>
          <div className={[styles.loading, !this.state.loading ? styles.hide : null].join(' ')}><LoaderDots /></div>
        </div>
        <div className={styles.footer}>
          {footerContent}
        </div>
      </div>
    );
  }
}

export default AppsIndex;
